import { Navigate, useLocation } from "react-router-dom";
// import { showNotification } from "./apiConfig/notification";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("token");
  useEffect(() => {}, [isAuthenticated]);
  if (!isAuthenticated) {
    // localStorage.setItem("path", window.location.href.split(".in")[1]);
    localStorage.setItem(
      "redirectAfterLogin",
      location.pathname + location.search
    );
    return <Navigate to="/" replace />;
  }

  return isAuthenticated ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
